var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCartArrowDownSolid = function SvgCartArrowDownSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    className: "svgr-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 7c-.55 0-1 .45-1 1s.45 1 1 1h2.219l2.625 10.5c.222.89 1.02 1.5 1.937 1.5H23.25c.902 0 1.668-.598 1.906-1.469L27.75 10h-2.094l-2.406 9H10.781L8.156 8.5A1.98 1.98 0 0 0 6.22 7Zm18 14c-1.645 0-3 1.355-3 3s1.355 3 3 3 3-1.355 3-3-1.355-3-3-3m-9 0c-1.645 0-3 1.355-3 3s1.355 3 3 3 3-1.355 3-3-1.355-3-3-3m3-14v5h-3l4 4 4-4h-3V7Zm-3 16c.563 0 1 .438 1 1s-.437 1-1 1-1-.437-1-1 .438-1 1-1m9 0c.563 0 1 .438 1 1s-.437 1-1 1-1-.437-1-1 .438-1 1-1"
  })));
};
export default SvgCartArrowDownSolid;